<template>
  <div>
    <h5>Audio para afiliados de Caja los Andes</h5>
    <b-form @submit="onSubmit" novalidate>
      <b-form-group
        id="identifier-group"
        label=""
        label-for="identifier"
        :description="client.input_info || ''"
      >
        <b-form-input
          id="identifier"
          v-model="form.identifier"
          type="text"
          :placeholder="client.input_placeholder || ''"
          :state="rutValidation"
          required
        ></b-form-input>
        <b-form-invalid-feedback :state="rutValidation">
          El RUT es obligatorio
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group>
        <b-form-checkbox
          id="terms-and-conditions"
          v-model="form.terms"
          name="terms"
          :state="termsAccepted"
          :value="true"
          :unchecked-value="false"
          @change="termsChanged"
        >
          <b-link target="_blank" :href="client.terms">
            Acepta Términos y Condiciones
          </b-link>
        </b-form-checkbox>
        <small
          v-if="termsAccepted === false"
          tabindex="-1"
          id="terms-and-conditions__BV_description_"
          class="form-text text-danger">
          Debes aceptar los términos y condiciones.
        </small>
      </b-form-group>
      <div class="d-flex justify-content-end align-items-center">
        <b-button type="submit" variant="primary">Continuar</b-button>
      </div>
    </b-form>
    <p
      class="text-center mt-5 text-success"
      v-if="validationStatus === 'SUCCESS'"
    >
      Muchas gracias, disfruta del audio tour.
    </p>
    <p
      class="text-center mt-5 text-danger"
      v-if="validationStatus === 'FAIL'"
    >
      No hemos podido validarte como afiliado, por favor comunícate con nosotros.
    </p>
  </div>

</template>
<script>
import Axios from 'axios';

export default {
  name: 'ClientValidationForm',
  props: {
    client: {
      require: true,
      type: Object,
    },
    validationSuccess: { type: Function },
  },
  data() {
    return {
      form: {
        identifier: null,
        terms: false,
      },
      termsAccepted: null,
      validationStatus: null,
    };
  },
  computed: {
    rutValidation() {
      const untouched = this.form.identifier === null;

      return untouched ? null : (this.form.identifier.length >= 8);
    },
  },
  methods: {
    termsChanged() {
      this.termsAccepted = null;
    },
    async onSubmit(e) {
      e.preventDefault();

      if (!this.form.identifier) {
        this.form.identifier = '';
        return;
      }

      if (!this.form.terms) {
        this.termsAccepted = false;
        return;
      }

      const params = {
        userId: null,
        clientId: this.client.id,
        identifier: this.form.identifier,
      };

      const success = await this.getClientValidation(params);
      const identifier = success ? this.form.identifier : null;

      localStorage.setItem('identifier', identifier);

      this.validationStatus = success ? 'SUCCESS' : 'FAIL';

      setTimeout(() => {
        this.$emit('validation-success', success);
      }, 2500);
    },
    async getClientValidation(params) {
      const url = process.env.NODE_ENV === 'production'
        ? `${process.env.VUE_APP_API_SERVER}/api/v1/clients/validate`
        : '/prod/api/v1/clients/validate';

      try {
        const { data: response } = await Axios.post(url, params);
        const { status, data } = response;

        if (status !== 200) return false;

        return data.process;
      } catch (error) {
        console.error(error);
        return false;
      }
    },
  },
};
</script>
